import { AnyAction, Dispatch } from 'redux';
import { handleErrorToast } from 'src/components/molecules';
import { AUTHENTICATION_TYPE, LOGIN_CODE } from '../api';
import axios from '../axios';
import {
  isVaultAuth,
  LoginFlow,
  LoginTypes,
  OrganisationTypes,
} from '../types';

export const setEmail = (email: string) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch({
    type: LoginTypes.EMAIL,
    payload: email,
  });
};

export const setFlow = (flow: LoginFlow) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch({
    type: LoginTypes.FLOW,
    payload: flow,
  });
};

export const getOrgAuthenticationType =
  (email: string, redirectURL?: string) =>
  async (dispatch: Dispatch<AnyAction>) => {
    try {
      const orgAuthTypeResult = await axios.post(AUTHENTICATION_TYPE, {
        email,
        redirectURL,
      });
      const { authenticationType } = orgAuthTypeResult.data.data;
      const { redirectUrl: redirectUrlSSO } = orgAuthTypeResult.data.data;

      dispatch({
        type: OrganisationTypes.FETCH_AUTH_TYPE,
        payload: { authenticationType },
      });

      if (!isVaultAuth(authenticationType)) {
        setFlow(LoginFlow.SSO)(dispatch);
        if (redirectUrlSSO) {
          window.open(redirectUrlSSO, '_top');
        }
      } else {
        setFlow(LoginFlow.PASSWORD)(dispatch);
      }
    } catch (error) {
      handleErrorToast({ toastMessage: 'Internal Server Error' });
    }
  };

export const get2FACode =
  (username: string, password: string) =>
  async (dispatch: Dispatch<AnyAction>) => {
    try {
      const result = await axios.post(LOGIN_CODE, {
        username,
        password,
      });

      if (result.status === 201) {
        setFlow(LoginFlow.CODE)(dispatch);
        return true;
      } else {
        throw new Error('Login Failed');
      }
    } catch (err) {
      const error = (
        err as {
          response: { data: { errors: { message: string }[] } };
        }
      )?.response?.data?.errors[0]?.message
        ? (
            err as {
              response: { data: { errors: { message: string }[] } };
            }
          ).response.data.errors[0].message
        : 'Login failed, email and/or password is incorrect.';
      handleErrorToast({ toastMessage: error });
      return false;
    }
  };
